import { createFileRoute } from '@tanstack/react-router';
import { eggStaticData } from '.';

export const Route = createFileRoute('/_private-routes/engagement/$id')({
  staticData: eggStaticData,
  preload: true,
  preloadStaleTime: 60 * 1000,
  staleTime: 60 * 1000
});
